var jade = require("D:\\Git\\projection-grid\\node_modules\\jade\\lib\\runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (classes) {
var tableStyle = {
  'border-collapse': 'collapse',
  'margin': 0,
};

buf.push("<div class=\"table-container\"><table" + (jade.attr("style", tableStyle, true, true)) + (jade.cls([classes], [true])) + "><colgroup class=\"column-group\"></colgroup><thead class=\"header\"></thead><tbody> <tr class=\"top-filler\"></tr><tr class=\"bottom-filler\"></tr></tbody><tfoot class=\"footer\"></tfoot></table></div>");}.call(this,"classes" in locals_for_with?locals_for_with.classes:typeof classes!=="undefined"?classes:undefined));;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./js/vnext/layout/table-static.jade
// module id = 99
// module chunks = 0